// Library Imports
import { lazy } from 'react';

// Local Imports
import { ROUTE_PATHS, ROUTE_NAMES } from '@/router/constants';
import { CreaterDashboardLayout } from '@/components/Shared/Layouts/CreaterDashboardLayout';

// Lazy load components for code splitting
const MediaKit = lazy(() => import('@/panels/Creater/MediaKit'));
const MediaKitDesktopPreview = lazy(() => import('@/panels/Creater/MediaKit/DesktopPreview'));
const ShareableLink = lazy(() => import('@/panels/Creater/Dashboard/ManageMediaKit/ShareableLink'));
const AuthenticateSocial = lazy(() => import('@/panels/Creater/Dashboard/ManageMediaKit/AuthenticateSocial'));
const BrandsReviews = lazy(() => import('@/panels/Creater/Dashboard/ManageMediaKit/BrandsReviews'));
const KitManagement = lazy(() => import('@/panels/Creater/Dashboard/ManageMediaKit/KitManagement'));
const Gifted = lazy(() => import('@/panels/Creater/Dashboard/CollabeCenter/Gifted'));
const Paid = lazy(() => import('@/panels/Creater/Dashboard/CollabeCenter/Paid'));
const ProfileAndAccount = lazy(() => import('@/panels/Creater/Dashboard/Profile/ProfileAndAccount'));
const UpgradeMediaKit = lazy(() => import('@/panels/Creater/Dashboard/Profile/UpgradeMediaKit'));
const UpgradeOffer = lazy(() => import('@/panels/Creater/Dashboard/Profile/UpgradeOffer'));
const ManageSubscription = lazy(() => import('@/panels/Creater/Dashboard/Profile/ManageSubscription'));

// Creator Private Routes
export const creatorRoutes = [
  {
    path: ROUTE_PATHS.MEDIA_KIT,
    moduleName: ROUTE_NAMES.MEDIA_KIT,
    element: <MediaKit />
  },
  {
    path: ROUTE_PATHS.MEDIA_KIT_DESKTOP_PREVIEW,
    moduleName: ROUTE_NAMES.MEDIA_KIT_DESKTOP_PREVIEW,
    element: <MediaKitDesktopPreview />
  },
  {
    path: ROUTE_PATHS.SHAREABLE_LINK,
    moduleName: ROUTE_NAMES.SHAREABLE_LINK,
    element: (
      <CreaterDashboardLayout>
        <ShareableLink />
      </CreaterDashboardLayout>
    )
  },
  {
    path: ROUTE_PATHS.AUTHENTICATE_SOCIAL,
    moduleName: ROUTE_NAMES.AUTHENTICATE_SOCIAL,
    element: (
      <CreaterDashboardLayout>
        <AuthenticateSocial />
      </CreaterDashboardLayout>
    )
  },
  {
    path: ROUTE_PATHS.BRANDS_REVIEWS,
    moduleName: ROUTE_NAMES.BRANDS_REVIEWS,
    element: (
      <CreaterDashboardLayout>
        <BrandsReviews />
      </CreaterDashboardLayout>
    )
  },
  {
    path: ROUTE_PATHS.KIT_MANAGEMENT,
    moduleName: ROUTE_NAMES.KIT_MANAGEMENT,
    element: (
      <CreaterDashboardLayout>
        <KitManagement />
      </CreaterDashboardLayout>
    )
  },
  {
    path: ROUTE_PATHS.GIFTED,
    moduleName: ROUTE_NAMES.GIFTED,
    element: (
      <CreaterDashboardLayout>
        <Gifted />
      </CreaterDashboardLayout>
    )
  },
  {
    path: ROUTE_PATHS.PAID,
    moduleName: ROUTE_NAMES.PAID,
    element: (
      <CreaterDashboardLayout>
        <Paid />
      </CreaterDashboardLayout>
    )
  },
  {
    path: ROUTE_PATHS.PROFILE_ACCOUNT,
    moduleName: ROUTE_NAMES.PROFILE_ACCOUNT,
    element: (
      <CreaterDashboardLayout>
        <ProfileAndAccount />
      </CreaterDashboardLayout>
    )
  },
  {
    path: ROUTE_PATHS.UPGRADE_MEDIA_KIT,
    moduleName: ROUTE_NAMES.UPGRADE_MEDIA_KIT,
    element: (
      <CreaterDashboardLayout>
        <UpgradeMediaKit />
      </CreaterDashboardLayout>
    )
  },
  {
    path: ROUTE_PATHS.UPGRADE_OFFER,
    moduleName: ROUTE_NAMES.UPGRADE_OFFER,
    element: (
      <CreaterDashboardLayout>
        <UpgradeOffer />
      </CreaterDashboardLayout>
    )
  },
  {
    path: ROUTE_PATHS.MANAGE_SUBSCRIPTION,
    moduleName: ROUTE_NAMES.MANAGE_SUBSCRIPTION,
    element: (
      <CreaterDashboardLayout>
        <ManageSubscription />
      </CreaterDashboardLayout>
    )
  },
];

